<template>
  <div
    class="py-1 border-l-2 border-primario xl:border-none"
    :class="[ index % 2 == 0 ? 'bg-white' : 'bg-gray-200' ]"
  >
    <label class="block text-xs leading-5 text-gray-700 pl-2">{{ label }}</label>
    <span class="block text-sm leading-5 text-gray-800 pl-2 font-semibold truncate">
      {{ data ? data : "Sin definir" }}
    </span>
  </div>
</template>

<script>
export default {
  name: "PlanningTableItem",
  props: {
    index: {
      type: [Number, String],
      required: true
    },
    data: {
      type: [String, Number],
      default: ""
    },
    label: {
      type: String,
      required: true
    }
  }
};
</script>
